var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Agregar Cabeceras HTTP" },
          on: { cerrar: _vm.handleCerrar }
        },
        [_c("GuardarButton", { on: { click: _vm.handleGuardar } })],
        1
      ),
      _c(
        "ContenidoModal",
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Información General" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:100",
                                    expression: "'required|max:100'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.nombre.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.nombre.id
                                  ),
                                  "data-vv-name": _vm.formFields.nombre.id,
                                  counter: 100
                                },
                                model: {
                                  value: _vm.formFields.nombre.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.nombre,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.nombre.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|max:100",
                                    expression: "'required|max:100'"
                                  }
                                ],
                                attrs: {
                                  label: _vm.formFields.valor.label,
                                  "error-messages": _vm.errors.collect(
                                    _vm.formFields.valor.id
                                  ),
                                  "data-vv-name": _vm.formFields.valor.id,
                                  counter: 100
                                },
                                model: {
                                  value: _vm.formFields.valor.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.valor, "value", $$v)
                                  },
                                  expression: "formFields.valor.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }